import { inject, injectable, interfaces } from 'inversify';
import { IConfiguration } from '../../configuration/config.types';
import { IAuthStore } from '../modules/auth/auth.store';
import { BaseHubService } from './baseHub.service';

export interface IUploadsHubService {
  initializeAsync(): Promise<void>;
  startUploadAsync(datasetId: string): Promise<void>;
  finishUploadAsync(datasetId: string): Promise<void>;
}

export namespace IUploadsHubService {
  export const $: interfaces.ServiceIdentifier<IUploadsHubService> = Symbol('UPLOAD_HUB_SERVICE');
}

const HUB_METHODS = {
  START_UPLOAD: 'StartUploadAsync',
  FINISH_UPLOAD: 'FinishUploadAsync',
};

@injectable()
export class UploadsHubService extends BaseHubService implements IUploadsHubService {
  constructor(@inject(IConfiguration.$) config: IConfiguration, @inject(IAuthStore.$) auth: IAuthStore) {
    super(auth, config.uploadsHubUrl);
  }

  async startUploadAsync(datasetId: string): Promise<void> {
    await this.connectAsync();
    await this.connection.invoke(HUB_METHODS.START_UPLOAD, {
      datasetId,
    });
  }

  async finishUploadAsync(datasetId: string): Promise<void> {
    await this.connectAsync();
    await this.connection.send(HUB_METHODS.FINISH_UPLOAD, {
      datasetId,
    });
  }
}
